import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { useQuery } from '@tanstack/react-query';
import { getAuthors } from '@dealstack/frontend/app/services/Blog.service.ts';
import { ApplicationType } from '@dealstack/shared/lib/generated';
import type { ClientPerspective } from '@sanity/client';

export const useAuthors = (
	dataset: ApplicationType,
	language: string,
	perspective?: ClientPerspective
) => {
	const request = useQuery({
		queryKey: [API_PATHS.HELP_BLOG_DATASET_AUTHORS_GET, { dataset, language, perspective }],
		queryFn: () =>
			getAuthors(API_PATHS.HELP_BLOG_DATASET_AUTHORS_GET, {
				dataset,
				language,
				perspective,
			}),
	});

	return {
		authors: request.data || [],
		isFetching: request.isFetching,
	};
};
